<script lang="ts">
  import type { CoachProfile, Game } from '$lib/types';

  import { createEventDispatcher } from 'svelte';
  import Image from '$components/Image.svelte';
  import MetafyPartnerBadge from '$components/icons/MetafyProBadge/MetafyPartnerBadge.svelte';
  import Avatar from '$components/Avatar.svelte';

  let className = '';
  export { className as class };
  export let expert:
    | CoachProfile
    | {
        id: string;
        name: string;
        bio: string;
        summary: string;
        avatar: string;
        games: {
          title: string;
          id: string;
        };
        is_pro: boolean;
        is_core: boolean;
      };
  export let avatarSizes = '';
  export let showSummary = false;
  export let showBio = false;
  export let partnerType = null;
  export let horizontal = false;

  const dispatch = createEventDispatcher();
</script>

<a
  class="group relative flex bg-transparent {className} focus-visible:bg-ondark-medium focus-visible:ring-ondark-focused flex-col rounded-lg focus-visible:outline-none focus-visible:ring-2"
  href="/@{expert?.slug}"
  on:click={() => dispatch('click', { expert })}
>
  <div class="flex {horizontal ? 'flex-row' : 'flex-col'}">
    <!-- PROFILE PIC -->
    <div
      class="bg-ondark-medium relative flex aspect-square items-center justify-center overflow-hidden rounded-lg transition-transform duration-300 {horizontal
        ? 'mr-4 h-auto'
        : 'w-auto'} {avatarSizes}"
    >
      <Avatar user={expert} size="w-full aspect-square" rounded="rounded-lg" />
    </div>

    <div class="flex flex-grow flex-col">
      <!-- NAME, PRICE -->
      <div class="flex w-full flex-col justify-between {horizontal ? 'w-full' : 'mt-4'}">
        <div class="mb-2 flex w-full flex-row items-center justify-between">
          <div class="truncate text-base font-semibold leading-6 text-white md:text-lg" title={expert?.name}>
            {expert._formatted?.name ?? expert?.name ?? ''}
          </div>

          {#if partnerType}
            <MetafyPartnerBadge variant={partnerType} size="xs" class="ml-1" />
          {/if}
        </div>
      </div>
      {#if showSummary && expert.summary}
        <div class="text-ondark-secondary mt-3 text-xs">
          <div class="line-clamp-3">
            {expert?.summary}
          </div>
        </div>
      {/if}
    </div>
  </div>

  {#if showBio && expert?.bio}
    <div class="text-ondark-secondary mt-3 line-clamp-3 text-xs">
      {expert?.bio}
    </div>
  {/if}
</a>
